const NotFound = () => {
  return <div>This is a 404 route.</div>;
};

export default NotFound;
